import { Box } from '@mui/material';
import styled from 'styled-components';

export const BoxForm = styled(Box)`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;
